import styled from "@emotion/styled";
import React, {useRef} from "react";
import {Button, css} from "@mui/material";
import {WarningRounded} from "@mui/icons-material";
import {useSelector, useDispatch} from "react-redux";
import {getPromPTModalState} from "modules/selectors/prompt_modal";
import {closePromptModal} from "modules/actions/prompt_modal";
import {useDialogModal} from "modules/utils";

const Wrapper = styled.dialog<{isOpen: boolean}>`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #000;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
	z-index: 999;
	display: none;
	@media (max-width: 880px) {
		position: fixed;
	}

	${(props) =>
		props.isOpen &&
		css`
			display: flex;
		`}
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 28px;
	line-height: 120%;
`;

const Description = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 130%;
	max-width: 300px;
	text-align: center;
	margin-top: 8px;
`;

const Header = styled.div`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;

	svg {
		width: 60px;
		height: auto;
		color: #f03b3b;
		margin-bottom: 20px;
	}
`;
const Buttons = styled.div`
	display: flex;
	flex-flow: column;
	gap: 12px;
	max-width: 280px;
	width: 100%;

	& > button {
		width: 100%;
	}
`;

export const PromptModal: React.FC = () => {
	const state = useSelector(getPromPTModalState);
	const modalRef = useRef<HTMLDialogElement>(null);
	const dispatch = useDispatch();

	useDialogModal(modalRef, !!state);

	if (!state) {
		return null;
	}

	const {title, description, confirmButton, denyButton} = state;

	const confirm = () => {
		if (confirmButton?.onClick) {
			confirmButton?.onClick();
		}
		dispatch(closePromptModal());
	};

	const deny = () => {
		if (denyButton?.onClick) {
			denyButton?.onClick();
		}
		dispatch(closePromptModal());
	};

	return (
		<Wrapper
			isOpen={!!state}
			aria-modal={true}
			role="alertdialog"
			aria-hidden={!state}
			ref={modalRef}
			onClose={(e) => {
				e.stopPropagation();
				deny();
			}}
		>
			<Header>
				<WarningRounded />
				<Title>{title}</Title>
				<Description>{description}</Description>
			</Header>
			<Buttons>
				<Button variant={"contained"} color={"error"} onClick={confirm}>
					{confirmButton.text}
				</Button>
				<Button variant={"contained"} onClick={deny}>
					{denyButton.text}
				</Button>
			</Buttons>
		</Wrapper>
	);
};
